// FahrerNew shows FahrerForm and FahrerFormReview
import React, { Component } from 'react'
import { reduxForm } from 'redux-form'
import LoginForm from './LoginForm'
import { connect } from 'react-redux';
import * as actions from '../../actions'

class Login extends Component {

	submit = values => {
		console.log(values);
		const cl = this.props.dispatch(actions.authenticateUser(values, this.props.history));
		console.log(cl);
	}

	renderContent() {

		console.log("Login aufgerufen");
		console.log(this.props.location.pathname);

		return (<LoginForm
			onLoginSubmit={this.submit} />
		);
	}

	render () {
		return (
			<div>
				{this.renderContent()}
			</div>
		)
	}
}

const loginForm = reduxForm({
	form: 'LoginForm'
})(Login);

export default connect(null, actions)(loginForm)



// WEBPACK FOOTER //
// ./src/components/login/Login.js